/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_64_TitleInputs */

const en_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four-Leaf Clover`)
};

const ar_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زهرة رباعية`)
};

const de_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vierblättriges Kleeblatt`)
};

const es_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trébol de cuatro hojas`)
};

const fr_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trèfle à quatre feuilles`)
};

const it_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadrifoglio`)
};

const ja_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四つ葉のクローバー`)
};

const ko_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네잎클로버`)
};

const pt_br_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trevo de quatro folhas`)
};

const ru_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Четырехлистный клевер`)
};

const th_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โคลเวอร์สี่แฉก`)
};

const tr_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dört Yapraklı Yonca`)
};

const zh_cn_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幸运草`)
};

const zh_tw_tree_type_64_title = /** @type {(inputs: Tree_Type_64_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幸運草`)
};

/**
* | output |
* | --- |
* | "Four-Leaf Clover" |
*
* @param {Tree_Type_64_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_64_title = /** @type {((inputs?: Tree_Type_64_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_64_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_64_title(inputs)
	if (locale === "ar") return ar_tree_type_64_title(inputs)
	if (locale === "de") return de_tree_type_64_title(inputs)
	if (locale === "es") return es_tree_type_64_title(inputs)
	if (locale === "fr") return fr_tree_type_64_title(inputs)
	if (locale === "it") return it_tree_type_64_title(inputs)
	if (locale === "ja") return ja_tree_type_64_title(inputs)
	if (locale === "ko") return ko_tree_type_64_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_64_title(inputs)
	if (locale === "ru") return ru_tree_type_64_title(inputs)
	if (locale === "th") return th_tree_type_64_title(inputs)
	if (locale === "tr") return tr_tree_type_64_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_64_title(inputs)
	return zh_tw_tree_type_64_title(inputs)
});